
const QuickSightEmbedding = require("amazon-quicksight-embedding-sdk");

interface settings {
url: string,
container: string,
height?: string,
width?: string,
}


class QuicksightQEmbed{
    frameOptions : any
    contentOptions : any
    dash : any
    setLoaded:any

    constructor(){
        this.frameOptions = {
            url: "",
            container: "",
            height:"100%",
            width:"100%",
        };
        this.contentOptions = {
            panelOptions: {
                panelType: 'FULL',
                title: 'Hey Alpha Insights!',
                showQIcon: false,
            },
            allowFullscreen: false,
            showTopicName: false,
            allowTopicSelection: false,
            showPinboard: false,
            searchPlaceholderText: 'Ask a Question',
            onMessage: async (messageEvent:any, experienceMetadata:any) => {
                switch (messageEvent.eventName) {
                    // case 'Q_SEARCH_OPENED': {
                    //     console.log("Do something when SEARCH_BAR type panel is expanded");
                    //     break;
                    // }
                    // case 'Q_SEARCH_FOCUSED': {
                    //     console.log("Do something when SEARCH_BAR type panel is focused");
                    //     break;
                    // }
                    // case 'Q_SEARCH_CLOSED': {
                    //     console.log("Do something when SEARCH_BAR type panel is collapsed");
                    //     break;
                    // }
                    // case 'Q_PANEL_ENTERED_FULLSCREEN': {
                    //     console.log("Do something when the experience enters full screen mode");
                    //     break;
                    // }
                    // case 'Q_PANEL_EXITED_FULLSCREEN': {
                    //     console.log("Do something when the experience exits full screen mode");
                    //     break;
                    // }
                    case 'CONTENT_LOADED': {
                        this.setLoaded(true);
                        break;
                    }
                    case 'ERROR_OCCURRED': {
                        console.log("Do something when an error occurs.");
                        console.log(messageEvent.message)
                        break;
                    }
                }
            }
            // themeOptions: {
            //     themeArn: 'arn:aws:quicksight:<Region>:<AWS-Account-ID>:theme/<Theme-ID>'
            // }
          }
    }

    public async init(setLoaded:any){
        this.setLoaded = setLoaded
        const embeddingContext = await QuickSightEmbedding.createEmbeddingContext()
        const {embedGenerativeQnA} = embeddingContext
        this.dash = embedGenerativeQnA
    }

    async embedDash(){
        try{
        return await this.dash(this.frameOptions,this.contentOptions)}
        catch (error){
            console.log(error)
        }
    }

    changeSettings({url,container,height,width} : settings){
        this.frameOptions.url = url
        this.frameOptions.container = container
        if(height){
            this.frameOptions.height=height

        }
        if(width){
            this.frameOptions.width=width
        }
    }


}

export default QuicksightQEmbed